"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTile = void 0;
const isTile = (type) => !isNaN(Number(type));
exports.isTile = isTile;
